module.exports = __webpack_public_path__ + "83cf7a8c7118bd7e142b258d25abedb2.svg";